import { fourierConfig } from "./config";
import { dinosaurModel } from "./dinosaurModel";
import { DINOSAUR_MODEL_SIZE, DINOSAUR_TRACE_WIDTH, dinosaurTheme } from "./dinosaurTheme";
import { samplePath } from "./math/samplePath";
import { dinosaur, dinosaurDetailPaths } from "./shapes/dinosaur";

const samples = samplePath(dinosaur, fourierConfig.sampleCount);
const center = samples.reduce(
  (sum, point) => ({ x: sum.x + point.x / samples.length, y: sum.y + point.y / samples.length }),
  { x: 0, y: 0 },
);
const extent = Math.max(
  Math.max(...samples.map((p) => p.x)) - Math.min(...samples.map((p) => p.x)),
  Math.max(...samples.map((p) => p.y)) - Math.min(...samples.map((p) => p.y)),
);
const scale = 2 * DINOSAUR_MODEL_SIZE / extent;

export const DinosaurArtwork = () => (
  <g fill="none" stroke={dinosaurTheme.colors.trail} strokeLinecap="round" strokeLinejoin="round">
    {/* Retain the actual 256-circle result; only the inner markings are SVG. */}
    <path d={dinosaurModel.stages[3].fullPath} strokeWidth={DINOSAUR_TRACE_WIDTH / fourierConfig.layout.finish.scale} />
    <g transform={`scale(${scale}) translate(${-center.x} ${-center.y})`} strokeWidth={DINOSAUR_TRACE_WIDTH / (fourierConfig.layout.finish.scale * scale)}>
      <circle cx="281" cy="303" r="14" />
      {dinosaurDetailPaths.map((path, i) => <path key={i} d={path} />)}
    </g>
  </g>
);
